import { Dialog, DialogContent, DialogHeading } from 'omakase';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { useRouteMatch } from 'react-router';
import React, { useState } from 'react';
import Signin, { SignInMode } from './Signin';

interface Props {
  postSignInPath?: string;
  isOpen: boolean;
  onClose(): void;
  onAuthComplete?(signInMode: SignInMode): void;
}

const DIALOG_TITLE = 'dialog-title';

const SignInDialog: React.FunctionComponent<Props> = ({
  postSignInPath,
  isOpen,
  onClose,
  onAuthComplete,
}) => {
  const [activeTab, setActiveTab] = useState<SignInMode>('login');
  const match = useRouteMatch();
  const handleChangeTab = (tab: SignInMode) => {
    setActiveTab(tab);
  };

  const getTitle = () => {
    switch (activeTab) {
      case 'login':
        return 'Log in to continue';
      case 'signup':
        return 'Sign up to continue';
      default:
        assertNever(activeTab);
    }
  };

  return (
    <Dialog aria-labelledby={DIALOG_TITLE} open={isOpen} onClose={onClose}>
      <DialogHeading id={DIALOG_TITLE} onClose={onClose}>
        {getTitle()}
      </DialogHeading>
      <DialogContent>
        <Signin
          tab={activeTab}
          postSigninPath={postSignInPath || match.url}
          hideHeader
          onChangeTab={handleChangeTab}
          onAuthComplete={onAuthComplete}
        ></Signin>
      </DialogContent>
    </Dialog>
  );
};

export default SignInDialog;
